export default __webpack_public_path__ + "static/media/P-017.2e64b900.png";